var _defs, _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.8117647 0 0 0 0 0.5882353 0 0 0 0 0.09803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z",
    fill: "#CF9619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8 15.2c4.418 0 8-3.403 8-7.6s-3.582-7.6-8-7.6-8 3.403-8 7.6 3.582 7.6 8 7.6z",
    fill: "#FFE063"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14A6.4 6.4 0 1 0 8 1.2 6.4 6.4 0 0 0 8 14Z",
    fill: "#EBBD31"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 5.239c0-1.12-7.2-.745-7.2-.745l3.208.745L4.857 11.6 7.21 8.262l.743-.272 2.432 3.61-1.45-4.282s2.266-.96 2.266-2.08ZM7.928 6.654l.556-1.293s1.244 0 1.244.32c0 .319-1.8.973-1.8.973Z",
    fill: "#BD6D01",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollcoin);
export default __webpack_public_path__ + "static/media/rollcoin.0c1a50ce8776aba5fca06c73d9b22719.svg";
export { ForwardRef as ReactComponent };